import React from "react";
import { useNavigate } from "react-router-dom";

export default function Logout() {
	const nav = useNavigate();

	document.cookie = "dynamicAuth=;expires=Thu, 01 Jan 1970 00:00:01 GMT";
	nav("/login");
	document.location.href = "/login";
	return <></>;
}
